export enum RecurrenceMode {
  once = 'once',
  repeatUntil = 'until',
  repeatForever = 'forever',
}
